import { createActions, createReducer } from 'reduxsauce'

import ConsultaPlanoPlurianualService from '../../servicos/ConsultaPlanoPlurianualService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaPlanoPlurianualInicio: [],
    buscaConsultaPlanoPlurianualErro: ['erro'],
    buscaConsultaPlanoPlurianualSucesso: ['consultaPlanoPlurianual'],
    limpar: [],
    setConsultaPlanoPlurianualEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaPlanoPlurianual = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaPlanoPlurianualInicio())
        let serv = new ConsultaPlanoPlurianualService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaPlanoPlurianualSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaPlanoPlurianualErro(error)))
    }
}

const buscaConsultaPlanoPlurianualInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaPlanoPlurianualErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaPlanoPlurianualSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaPlanoPlurianual.resultado,
        dataSincronizacaoDados: action.consultaPlanoPlurianual.dataSincronizacaoDados,
        fonte: action.consultaPlanoPlurianual.fonte,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaPlanoPlurianualEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_PLANO_PLURIANUAL_INICIO]: buscaConsultaPlanoPlurianualInicio,
    [Types.BUSCA_CONSULTA_PLANO_PLURIANUAL_ERRO]: buscaConsultaPlanoPlurianualErro,
    [Types.BUSCA_CONSULTA_PLANO_PLURIANUAL_SUCESSO]: buscaConsultaPlanoPlurianualSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_PLANO_PLURIANUAL_ESTADO_DT]: setConsultaPlanoPlurianualEstadoDT,
})
